t = require('app/scripts/views/internal/teacup-with-helpers')('popover_move_card')

module.exports = ->
  t.mustachePartial 'move_card_controls'

  t.input '.primary.wide.js-submit', { type: 'submit', value: t.l('move') }
